import "../SCSS/styles.css";
import { MatrixComponentProps, TOnWheelMatrix } from "../MatrixTypeProps";
import {
  EnumSurveyAnswerStatus,
  formulaTypes,
  formulaTypesMapping,
  MatrixTextFieldType,
  MatrixTypesEnum,
} from "../../../Common/Enums/EnumsTypes";

function Matrix({
  surveyAnswersInfo,
  questionId,
  handleChangeCheckbox,
  surveyAnswers,
  handleChangeTextField,
  isPreview,
  handleChangeNumberField,
}: MatrixComponentProps) {
  const matrixInfo =
    surveyAnswersInfo.surveyInfo.questionsInfo.questionObj?.[questionId]
      ?.matrixInfo;
  console.log("matrixInfo", matrixInfo);

  let inputStyle = (
    i: number,
    j: number
  ): {
    [key: string]: string | number;
  } => {
    return {
      border: "1px solid #0002",
      padding: "4px",
      outline: "none",
      textAlign: "center",
      minWidth:
        matrixInfo?.colObj?.[matrixInfo.colOrder[j]]?.matrixType?.textType ===
        MatrixTextFieldType.SHORT
          ? "100px"
          : "200px",
    };
  };
  let inputStyleNumber: {
    [key: string]: string | number;
  } = {
    border: "1px solid #0002",
    padding: "4px",
    outline: "none",
    textAlign: "center",
    minWidth: "30px",
    WebkitAppearance: "none",
    MozAppearance: "textfield",
  };
  const renderMatrixTypes = (
    matrixType: string | undefined,
    i: number,
    j: number
  ) => {
    switch (matrixType) {
      case MatrixTypesEnum.CHECKBOX:
        return (
          <input
            type="checkbox"
            onChange={(event) =>
              surveyAnswersInfo?.surveyStatus !==
                EnumSurveyAnswerStatus?.COMPLETED &&
              handleChangeCheckbox(event, questionId, `${i}${j}`)
            }
            checked={
              surveyAnswers?.[questionId]?.val?.[`${i}${j}`]?.rowIndex ===
              `${i}${j}`
            }
            // checked={
            //   surveyAnswers[questionId] &&
            //   `${i}${j}` in surveyAnswers[questionId].val
            // }
            disabled={
              isPreview ||
              surveyAnswersInfo?.surveyStatus ===
                EnumSurveyAnswerStatus?.COMPLETED
            }
          />
        );

      case MatrixTypesEnum.NUMBER:
        return (
          <input
            type="number"
            style={inputStyleNumber}
            className="input-number"
            onWheel={(e: TOnWheelMatrix) => e.target.blur()}
            onChange={(event) =>
              surveyAnswersInfo?.surveyStatus !==
                EnumSurveyAnswerStatus?.COMPLETED &&
              handleChangeNumberField(event, questionId, `${i}${j}`)
            }
            value={surveyAnswers?.[questionId]?.val?.[`${i}${j}`] ?? ""}
            disabled={
              isPreview ||
              surveyAnswersInfo?.surveyStatus ===
                EnumSurveyAnswerStatus?.COMPLETED
            }
          />
        );
      default:
        return (
          <input
            type="text"
            style={inputStyle(i, j)}
            className="input-text"
            onChange={(event) =>
              surveyAnswersInfo?.surveyStatus !==
                EnumSurveyAnswerStatus?.COMPLETED &&
              handleChangeTextField(event, questionId, `${i}${j}`)
            }
            value={surveyAnswers?.[questionId]?.val?.[`${i}${j}`] ?? ""}
            disabled={
              isPreview ||
              surveyAnswersInfo?.surveyStatus ===
                EnumSurveyAnswerStatus?.COMPLETED
            }
            maxLength={
              matrixInfo?.colObj?.[matrixInfo.colOrder[j]]?.matrixType
                ?.textType === MatrixTextFieldType.SHORT
                ? 10
                : 50
            }
          />
        );
    }
  };
  return (
    <div className="supplier-view-matrix-cover">
      <div className="table-responsive">
        <table className="matrix-table">
          <thead>
            <tr>
              <th colSpan={matrixInfo?.colOrder.length! + 1}>
                {matrixInfo?.colName}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{matrixInfo?.rowName}</td>
              <thead>
                <tr>
                  <th></th>
                  {matrixInfo?.colOrder.map((colId) => (
                    <th key={colId}>
                      {matrixInfo?.colObj?.[colId]?.isMandatory && (
                        <span className="mandatory-fields">*</span>
                      )}
                      {matrixInfo?.colObj?.[colId]?.colLabel}

                      {matrixInfo.colObj?.[colId]?.matrixType?.name ===
                        MatrixTypesEnum.NUMBER &&
                        matrixInfo?.grandTotalInfo?.columns?.isEnabled &&
                        matrixInfo?.colObj?.[colId]?.colLabel &&
                        matrixInfo.colObj?.[colId]?.formulaInfo?.calcType! && (
                          <span className="formula-tag">
                            {
                              formulaTypesMapping[
                                matrixInfo.colObj?.[colId]?.formulaInfo
                                  ?.calcType!
                              ]
                            }
                          </span>
                        )}
                    </th>
                  ))}
                  {matrixInfo?.grandTotalInfo?.rows?.isEnabled && (
                    <th>Total</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {matrixInfo?.rowOrder.map((rowId, i) => (
                  <tr key={rowId}>
                    <td>
                      {matrixInfo?.rowObj?.[rowId]?.isMandatory && (
                        <span className="mandatory-fields">*</span>
                      )}
                      {matrixInfo?.rowObj?.[rowId]?.rowLabel}
                      {matrixInfo?.rowObj?.[rowId]?.rowLabel &&
                        matrixInfo?.grandTotalInfo?.rows?.isEnabled &&
                        matrixInfo.rowObj?.[rowId]?.formulaInfo?.calcType! && (
                          <span className="formula-tag">
                            {
                              formulaTypesMapping[
                                matrixInfo.rowObj?.[rowId]?.formulaInfo
                                  ?.calcType!
                              ]
                            }
                          </span>
                        )}
                    </td>
                    {matrixInfo?.colOrder.map((colId, j) => (
                      <td key={colId}>
                        {renderMatrixTypes(
                          matrixInfo.colObj?.[colId]?.matrixType?.name,
                          i,
                          j
                        )}
                      </td>
                    ))}

                    {matrixInfo?.grandTotalInfo?.rows?.isEnabled && (
                      <td>
                        {matrixInfo?.colOrder.some(
                          (colId) =>
                            matrixInfo.colObj?.[colId]?.matrixType?.name ===
                            MatrixTypesEnum.NUMBER
                        )
                          ? matrixInfo?.rowObj[rowId]?.formulaInfo
                              ?.grandTotalThreshold ??
                            (surveyAnswers?.[questionId]?.val?.[
                              `${i}${matrixInfo?.colOrder?.length}`
                            ] ||
                              0)
                          : "-"}
                      </td>
                    )}
                  </tr>
                ))}

                {matrixInfo?.grandTotalInfo?.columns?.isEnabled && (
                  <tr>
                    <td>Total</td>

                    {/* Empty cells for each column */}
                    {matrixInfo?.colOrder.map((colId, j) => (
                      <td key={colId}>
                        {matrixInfo.colObj?.[colId]?.matrixType?.name ===
                        MatrixTypesEnum.NUMBER
                          ? matrixInfo?.colObj[colId]?.formulaInfo
                              ?.grandTotalThreshold ??
                            (surveyAnswers?.[questionId]?.val?.[
                              `${matrixInfo?.rowOrder?.length}${j}`
                            ] ||
                              0)
                          : "-"}
                      </td>
                    ))}

                    {/* Add final Total column if rows.isEnabled is also true */}
                    {/* {matrixInfo?.grandTotalInfo?.rows?.isEnabled && (
                      <td>
                        {Object.values(totalsByRowAndColumn?.rowTotals).reduce(
                          (sum, val) => sum + val,
                          0
                        )}

                        {(() => {
                          const { rowTotals = {}, colTotals = {} } =
                            totalsByRowAndColumn || {};

                          let rowTotalSum = 0;
                          for (const rowKey in rowTotals) {
                            let val = Number(rowTotals[rowKey]) || 0;
                            const threshold =
                              matrixInfo?.rowObj?.[rowKey]?.formulaInfo
                                ?.grandTotalThreshold;
                            if (threshold) {
                              val = Number(threshold);
                            }

                            rowTotalSum += val;
                          }

                          let colTotalSum = 0;
                          for (const colKey in colTotals) {
                            let val = Number(colTotals[colKey]) || 0;
                            const threshold =
                              matrixInfo?.colObj[colKey]?.formulaInfo
                                ?.grandTotalThreshold;

                            if (threshold) {
                              val = Number(threshold);
                            }
                            colTotalSum += val;
                          }

                          const finalTotal = rowTotalSum + colTotalSum;
                          return finalTotal;
                        })()}
                      </td>
                    )} */}
                  </tr>
                )}
              </tbody>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Matrix;
